// import React, { useState } from "react";
// import { JOB_BASE_URL } from "../services/jobService";
// import axios from "axios";
// import { useAuthContext } from "../hooks/useAuthContext";
// import { Link, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";

// const AddNewJobs = () => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [error, setError] = useState(null);
//   const { user } = useAuthContext();
//   const [jobTitle, setJobTitle] = useState("");
//   const [employmentType, setEmploymentType] = useState("");
//   const [remoteType, setRemoteType] = useState("");
//   const [salary, setSalary] = useState(0);
//   const [description, setDescription] = useState("");

//   const [location, setLocation] = useState({
//     city: "",
//     state: "",
//     country: "",
//   });
//   const [companyName, setCompanyName] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);

//     if (!user || !user.token) {
//       setError("User authentication required. Please log in.");
//       setLoading(false);
//       return;
//     }

//     const jobData = {
//       jobTitle,
//       employmentType,
//       remoteType,
//       salary,
//       description,
//       location,
//       companyName,
//     };

//     try {
//       const response = await axios.post(
//         `${JOB_BASE_URL}/api/jobs/create`,
//         jobData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${user.token}`,
//           },
//         }
//       );

//       Swal.fire({
//         position: "top-center",
//         icon: "success",
//         title: "Success",
//         text: "New job added successfully!",
//         showConfirmButton: false,
//         timer: 2500,
//       });
//       if (response.status === 201) {
//         setJobTitle("");
//         setEmploymentType("");
//         setRemoteType("");
//         setSalary("");
//         setDescription("");
//         setLocation({ city: "", state: "", country: "" });
//         setCompanyName("");

//         setTimeout(() => {
//           navigate("/api/jobs/all-jobs");
//         }, 3000);
//       } else {
//         console.log("Unexpected response:", response.status);
//         setError("Unexpected error occurred. Please try again.");
//       }
//     } catch (error) {
//       console.error(
//         "Error creating job:",
//         error.response ? error.response.data : error.message
//       );
//       setError(
//         error.response?.data?.message ||
//           `Failed to create job. Please check your input. Error: ${error.message}`
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="add-job vh-100 bg-white">
//       <div className="container mt-5">
//         <h1 className="text-primary">Post New Job</h1> <hr />{" "}
//         {error && <p className="alert alert-warning">{error}</p>}
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label className="form-label">Job Title</label>
//             <input
//               type="text"
//               className="form-control form-control-lg"
//               value={jobTitle}
//               onChange={(e) => setJobTitle(e.target.value)}
//               required
//             />
//           </div>

//           <div className="row mb-3">
//             <div className="col">
//               <label className="form-label">Employment Type</label>
//               <select
//                 className="form-select form-control-lg"
//                 value={employmentType}
//                 onChange={(e) => setEmploymentType(e.target.value)}
//                 required
//               >
//                 <option value="" disabled>
//                   Select
//                 </option>
//                 <option value="Full-time">Full-time</option>
//                 <option value="Part-time">Part-time</option>
//                 <option value="Freelance">Freelance</option>
//                 <option value="Internship">Internship</option>
//                 <option value="Contract">Contract</option>
//               </select>
//             </div>
//             <div className="col">
//               <label className="form-label">Remote Type</label>
//               <select
//                 className="form-select form-control-lg"
//                 value={remoteType}
//                 onChange={(e) => setRemoteType(e.target.value)}
//                 required
//               >
//                 <option value="" disabled>
//                   Select
//                 </option>
//                 <option value="Remote-Only">Remote-Only</option>
//                 <option value="Office-Only">Office-Only</option>
//                 <option value="Partial-Remote">Partial-Remote</option>
//               </select>
//             </div>
//             <div className="col">
//               <label className="form-label">Salary</label>
//               <input
//                 type="number"
//                 className="form-control form-control-lg"
//                 value={salary}
//                 onChange={(e) => setSalary(e.target.value)}
//                 required
//               />
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Description</label>
//             <textarea
//               className="form-control form-control-lg"
//               rows="5"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               placeholder="Enter job description"
//               required
//             ></textarea>
//           </div>

//           <div className="row mb-3">
//             <div className="col">
//               <label className="form-label">City</label>
//               <input
//                 type="text"
//                 className="form-control form-control-lg"
//                 value={location.city}
//                 onChange={(e) =>
//                   setLocation({ ...location, city: e.target.value })
//                 }
//                 required
//                 placeholder="Enter city"
//               />
//             </div>
//             <div className="col">
//               <label className="form-label">State</label>
//               <input
//                 type="text"
//                 className="form-control form-control-lg"
//                 value={location.state}
//                 onChange={(e) =>
//                   setLocation({ ...location, state: e.target.value })
//                 }
//                 required
//                 placeholder="Enter state"
//               />
//             </div>
//             <div className="col">
//               <label className="form-label">Country</label>
//               <input
//                 type="text"
//                 className="form-control form-control-lg"
//                 value={location.country}
//                 onChange={(e) =>
//                   setLocation({ ...location, country: e.target.value })
//                 }
//                 required
//                 placeholder="Enter country"
//               />
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Company Name</label>
//             <input
//               type="text"
//               className="form-control form-control-lg"
//               value={companyName}
//               onChange={(e) => setCompanyName(e.target.value)}
//               required
//               placeholder="Enter company name"
//             />
//           </div>

//           <button
//             type="submit"
//             className="btn btn-primary btn-lg"
//             disabled={loading}
//           >
//             {loading ? "Submitting..." : "Save"}
//           </button>
//           <Link to="/api/jobs/all-jobs" className="btn btn-danger btn-lg ms-2">
//             Cancel
//           </Link>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default AddNewJobs;


import React, { useState } from "react";
import { JOB_BASE_URL } from "../services/jobService";
import axios from "axios";
import { useAuthContext } from "../hooks/useAuthContext";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const AddNewJobs = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const { user } = useAuthContext();
  const [formData, setFormData] = useState({
    jobTitle: "",
    employmentType: "",
    remoteType: "",
    salary: "",
    description: "",
    location: {
      city: "",
      state: "",
      country: "",
    },
    companyName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLocationChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      location: {
        ...prev.location,
        [name]: value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!user?.token) {
      setError("You must be logged in to post a job");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${JOB_BASE_URL}/api/jobs/create`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (response.status === 201) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Job Posted Successfully!",
          showConfirmButton: false,
          timer: 2000,
          backdrop: `
            rgba(0,0,123,0.4)
            url("/images/nyan-cat.gif")
            left top
            no-repeat
          `,
        });

        // Reset form
        setFormData({
          jobTitle: "",
          employmentType: "",
          remoteType: "",
          salary: "",
          description: "",
          location: {
            city: "",
            state: "",
            country: "",
          },
          companyName: "",
        });

        setTimeout(() => navigate("/api/jobs/all-jobs"), 2000);
      }
    } catch (error) {
      console.error("Error creating job:", error);
      setError(
        error.response?.data?.message ||
          "Failed to create job. Please check your input."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8">
          <div className="card border-0 shadow-lg">
            <div className="card-header bg-primary text-white py-3">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="mb-0">
                  <i className="fa fa-plus-circle me-2"></i>
                  Post a New Job
                </h2>
                <Link to="/api/jobs/all-jobs" className="btn btn-light btn-sm">
                  <i className="fa fa-arrow-left me-1"></i> Back to Jobs
                </Link>
              </div>
            </div>

            <div className="card-body p-4">
              {error && (
                <div className="alert alert-danger alert-dismissible fade show">
                  <i className="fa fa-exclamation-circle me-2"></i>
                  {error}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setError(null)}
                  ></button>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <h5 className="text-primary mb-3">
                    <i className="fa fa-info-circle me-2"></i>
                    Job Information
                  </h5>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Job Title*</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="jobTitle"
                      value={formData.jobTitle}
                      onChange={handleChange}
                      placeholder="e.g. Senior React Developer"
                      required
                    />
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col-md-4">
                      <label className="form-label fw-bold">
                        Employment Type*
                      </label>
                      <select
                        className="form-select form-select-lg"
                        name="employmentType"
                        value={formData.employmentType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select type</option>
                        <option value="Full-time">Full-time</option>
                        <option value="Part-time">Part-time</option>
                        <option value="Freelance">Freelance</option>
                        <option value="Internship">Internship</option>
                        <option value="Contract">Contract</option>
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">
                        Work Arrangement*
                      </label>
                      <select
                        className="form-select form-select-lg"
                        name="remoteType"
                        value={formData.remoteType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select arrangement</option>
                        <option value="Remote-Only">Remote-Only</option>
                        <option value="Office-Only">Office-Only</option>
                        <option value="Partial-Remote">Partial-Remote</option>
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">
                        Salary (USD)*
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="salary"
                          value={formData.salary}
                          onChange={handleChange}
                          placeholder="Annual salary"
                          min="0"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Job Description*
                    </label>
                    <textarea
                      className="form-control form-control-lg"
                      rows="6"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Detailed job description, requirements, benefits..."
                      required
                    ></textarea>
                    <div className="form-text">
                      Markdown formatting supported
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5 className="text-primary mb-3">
                    <i className="fa fa-building me-2"></i>
                    Company Details
                  </h5>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Company Name*</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      placeholder="Your company name"
                      required
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <h5 className="text-primary mb-3">
                    <i className="fa fa-map-marker me-2"></i>
                    Location Information
                  </h5>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label fw-bold">City*</label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="city"
                        value={formData.location.city}
                        onChange={handleLocationChange}
                        placeholder="e.g. San Francisco"
                        required
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">
                        State/Province*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="state"
                        value={formData.location.state}
                        onChange={handleLocationChange}
                        placeholder="e.g. California"
                        required
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">Country*</label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="country"
                        value={formData.location.country}
                        onChange={handleLocationChange}
                        placeholder="e.g. United States"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-3 mt-4">
                  <Link
                    to="/api/jobs/all-jobs"
                    className="btn btn-outline-danger btn-lg"
                  >
                    <i className="fa fa-times me-2"></i> Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg px-4"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Posting Job...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane me-2"></i> Post Job
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewJobs;